const budgetParametersMargeHeader = [
  {
    group: 'CALCULO MARGEM MEDIA',
    columns: [
      {
        name: 'Id',
        id: 'calculo-id',
        show: false
      },
      {
        name: 'Empresa',
        id: 'calculo-empresa',
        show: true
      },
      {
        name: 'Categoria Compacta',
        id: 'calculo-categoria',
        show: true
      },
      {
        name: 'Realizada 3 Meses',
        id: 'calculo-realizada',
        show: true
      },
      {
        name: 'Proposta',
        id: 'calculo-proposta',
        show: true
      }
    ]
  }
]

export default budgetParametersMargeHeader
